import * as React from 'react';
import { Hr, Paragraph } from '../../../../elements';
import TwoColRow from './TwoColRow';
const SeizureAttemptsRow = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    !!value.quantity && (React.createElement("div", null,
        React.createElement(Hr, null),
        value.distraints.map((distraint, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement(TwoColRow, { label: i18n('common.description'), value: distraint.description }),
            React.createElement(TwoColRow, { label: i18n('common.comment'), value: distraint.comment }),
            React.createElement(TwoColRow, { label: i18n('common.date'), value: formatDate(distraint.date) }),
            React.createElement("br", null)))))),
    value.comment != '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--medium' },
        React.createElement(Paragraph, { bold: true }, i18n('common.note')),
        React.createElement("div", { className: 'ReadReportContent__NotationContent' },
            React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
export default SeizureAttemptsRow;
